import type { GuideQuestionCategoryDef } from "../types/guide-content.types.ts"

/**
 * One entry per Q&A category, each gated the same way a `GuideModule`/
 * `ProductTourStep` is — a bare `pages` entry or a `category.section.key`
 * dot-path resolved against `permissions.codes`. "getting-started" carries
 * no gate at all, same as `start-here`.
 */
export const GUIDE_QUESTION_CATEGORIES: GuideQuestionCategoryDef[] = [
  { id: "getting-started", titleKey: "guide.qa.categories.gettingStarted" },
  { id: "leads", titleKey: "guide.qa.categories.leads", requiredPage: "leads" },
  { id: "projects", titleKey: "guide.qa.categories.projects", requiredPage: "projects" },
  {
    id: "milestones",
    titleKey: "guide.qa.categories.milestones",
    requiredPage: "projects.milestones.project_milestone_view"
  },
  {
    id: "finance",
    titleKey: "guide.qa.categories.finance",
    requiredPage: "projects.finances.project_finance_view"
  },
  {
    id: "invoices",
    titleKey: "guide.qa.categories.invoices",
    requiredPage: "projects.invoices.project_invoice_view"
  },
  {
    id: "tasks",
    titleKey: "guide.qa.categories.tasks",
    requiredPage: "projects.checklists.project_checklist_view"
  },
  { id: "files", titleKey: "guide.qa.categories.files", requiredPage: "leads" },
  { id: "calendar", titleKey: "guide.qa.categories.calendar", requiredPage: "calendar" },
  { id: "customers", titleKey: "guide.qa.categories.customers", requiredPage: "customers" },
  {
    id: "subcontractors",
    titleKey: "guide.qa.categories.subcontractors",
    requiredPage: "subcontractors"
  },
  { id: "notifications", titleKey: "guide.qa.categories.notifications" },
  { id: "settings", titleKey: "guide.qa.categories.settings", requiredPage: "settings" }
]

export const getQuestionCategory = (id: string): GuideQuestionCategoryDef | null =>
  GUIDE_QUESTION_CATEGORIES.find((category) => category.id === id) ?? null
